module.exports = __webpack_public_path__ + "static/media/PDFicon.4c042161.svg";